<template>
  <div class="error-box">
    <div class="error-body text-center">
      <h1 class="error-title text-danger">404</h1>
      <h3 class="text-uppercase error-subtitle">PAGE NOT FOUND !</h3>
      <p class="text-muted mt-4 mb-4">YOU SEEM TO BE TRYING TO FIND HIS WAY HOME</p>
      <a
        href="javascript:void(0)"
        @click="backLink"
        class="btn btn-danger btn-rounded waves-effect waves-light mb-5"
      >Back to home</a>
    </div>
  </div>
</template>

<script>
import VueJwtDecode from 'vue-jwt-decode'
export default {
  methods: {
    backLink () {
      const jwt = VueJwtDecode.decode(sessionStorage.token)
      if (jwt !== null) {
        this.defaultRoute(jwt.role_id)
      } else {
        window.location.href = '/'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/404.vue